"use strict";
import { COLORS } from "./chartColors";
export const applicationCountStatusTransformer = (data, selectedEntities) => {
  const monthlyStatusCounts = {};
  const allStatus = /* @__PURE__ */ new Set();
  Object.entries(data).forEach(([key, value]) => {
    const [entity_id, year, month] = key.split("_");
    const monthLabel = `${year}-${month.padStart(2, "0")}`;
    const isAllSelected = selectedEntities == null ? void 0 : selectedEntities.some((entity) => entity.name === "All");
    const isEntitySelected = selectedEntities == null ? void 0 : selectedEntities.some(
      (entity) => entity.id.toString() === entity_id
    );
    if (selectedEntities && !isAllSelected && !isEntitySelected) return;
    if (!monthlyStatusCounts[monthLabel]) monthlyStatusCounts[monthLabel] = {};
    if (Array.isArray(value.data)) {
      value.data.forEach((record) => {
        const status = record.status || "unknown";
        allStatus.add(status);
        monthlyStatusCounts[monthLabel][status] = (monthlyStatusCounts[monthLabel][status] || 0) + 1;
      });
    } else if (!value.data.reportNotFound) {
      return;
    }
  });
  const sortedLabels = Object.keys(monthlyStatusCounts).sort();
  const datasets = Array.from(allStatus).map((status, index) => ({
    label: status,
    data: sortedLabels.map((label) => monthlyStatusCounts[label][status] || 0),
    backgroundColor: COLORS[index % COLORS.length],
    borderWidth: 1,
    stack: "applicationStatus"
  }));
  return {
    labels: sortedLabels,
    datasets
  };
};
